import { render, staticRenderFns } from "./orderAmountModificationModal.vue?vue&type=template&id=45546052"
import script from "./orderAmountModificationModal.vue?vue&type=script&lang=js"
export * from "./orderAmountModificationModal.vue?vue&type=script&lang=js"
import style0 from "./orderAmountModificationModal.vue?vue&type=style&index=0&id=45546052&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports